import { I18nUtils } from '@medable/i18n-core';
export const formatLanguageOptions = (locales, currentLocale) => {
    const showOwnLocale = true;
    //  c_supported_locales can contain duplicate entries that only differ by format (e.g. `en-US` and `en_US`), which
    //  render the same label; dedupe by normalized locale, keeping the first occurrence, to avoid repeated options.
    const seen = new Set();
    const uniqueLocales = locales.filter((locale) => {
        const key = I18nUtils.i18nToCortexFormat(locale);
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
    return uniqueLocales.length
        ? uniqueLocales.map((locale) => ({
            value: locale,
            label: I18nUtils.getLanguageLabel(locale, currentLocale, showOwnLocale),
        }))
        : [];
};
